import { Enum, EnumType } from 'ts-jenum';

@Enum<ThemeType>('value')
export class ThemeType extends EnumType<ThemeType>() {
   public static readonly DEFAULT = new ThemeType('DEFAULT', 'theme-default', 'theme-dark', 'common.global_settings.theme.types.default', 'light');
   public static readonly DARK = new ThemeType('DARK', 'theme-dark', 'theme-dark', 'common.global_settings.theme.types.dark', 'dark');
   public static readonly LIGHT = new ThemeType('LIGHT', 'theme-default', 'theme-default', 'common.global_settings.theme.types.light', 'light');
   public static readonly MS_TEAMS_LIGHT = new ThemeType(
      'MS_TEAMS_LIGHT',
      'theme-ms-teams-light',
      'theme-ms-teams-light',
      'common.global_settings.theme.types.ms_teams_light',
      'light'
   );
   public static readonly MS_TEAMS_DARK = new ThemeType(
      'MS_TEAMS_DARK',
      'theme-ms-teams-dark',
      'theme-ms-teams-dark',
      'common.global_settings.theme.types.ms_teams_dark',
      'dark'
   );

   private constructor(
      public value: string,
      public className: string,
      public alternativeTheme: string,
      public translationKey: string,
      public grafanaThemeName: string
   ) {
      super();
   }
}
